window.mobileCart = (function() {
  const selectors = {
    drawer: '#mobile-cart-drawer',
    sheet: '#mobile-drawer-sheet',
    overlay: '#mobile-drawer-overlay',
    loading: '#mobile-drawer-loading',
    loadingText: '#mobile-drawer-loading-text', 
    handle: '#mobile-drawer-handle',
    header: '.drawer-header',
    peek: '#mobile-drawer-peek',
    closeBtn: '#btn-close-drawer',
    peekImg: '#peek-img-target',
    peekTitle: '#peek-title-target',
    peekPrice: '#peek-price-target',
    totalPrice: '#drawer-total-price',
    btnOpenPkg: '#btn-open-packaging',
    btnClosePkg: '#btn-close-packaging',
    countElements: '.cart-count, .header__cart-count, .header__icons--cart-open .cart-count, #cart-icon-bubble span, .count, .smart-cart-count',
    checkoutBtn: '#btn-mobile-checkout',
    cartForm: '#mobile-cart-form'
  };

  let drawer, sheet, handle, peek, overlay, headerArea, loadingOverlay;
  let startY, currentY, isDragging = false;
  let peekTimer = null;
  let undoToastTimer = null;
  let cartRoot = '/';
  
  // États
  let debounceTimer = null;
  let isBusy = false;
  let isErrorState = false; 

  function isDesktop() { return window.innerWidth >= 1024; }
  function triggerHaptic() { if (navigator.vibrate) navigator.vibrate(50); }

  function t(key, fallback) {
    if (window.mobileCartStrings && window.mobileCartStrings[key]) {
      return window.mobileCartStrings[key];
    }
    return fallback;
  }

  function buildUrl(path) {
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return cartRoot === '/' ? '/' + cleanPath : cartRoot + '/' + cleanPath;
  }

  function init() {
    drawer = document.querySelector(selectors.drawer);
    if (!drawer) return;

    const rawRoot = drawer.getAttribute('data-root');
    if (rawRoot) {
      cartRoot = rawRoot.endsWith('/') && rawRoot.length > 1 ? rawRoot.slice(0, -1) : rawRoot;
    }

    sheet = document.querySelector(selectors.sheet);
    handle = document.querySelector(selectors.handle);
    peek = document.querySelector(selectors.peek);
    overlay = document.querySelector(selectors.overlay);
    headerArea = document.querySelector(selectors.header);
    loadingOverlay = document.querySelector(selectors.loading);

    bindEvents();
    hijackCartForms();

    // --- AUTO-OUVERTURE APRES LE RETOUR DE CLOUDFLARE ---
    if (sessionStorage.getItem('mcd-reopen-after-refresh')) {
        sessionStorage.removeItem('mcd-reopen-after-refresh');
        setTimeout(() => expand(), 500); 
    }
  }

  // --- GESTION DU VOILE BLANC ---
  function setLoading(active, message = null) {
    if (!loadingOverlay || !sheet) return;
    
    const textEl = loadingOverlay.querySelector('.loading-text') || createLoadingText(loadingOverlay);

    if (active) {
      isBusy = true;
      loadingOverlay.style.display = 'flex';
      sheet.style.pointerEvents = 'none'; 
      
      if (message) {
        textEl.textContent = message;
        textEl.style.display = 'block';
        loadingOverlay.querySelector('.loading-spinner').style.display = 'none'; 
      } else {
        textEl.style.display = 'none';
        loadingOverlay.querySelector('.loading-spinner').style.display = 'block';
      }

      requestAnimationFrame(() => loadingOverlay.style.opacity = '1');
    } else {
      loadingOverlay.style.opacity = '0';
      setTimeout(() => {
        loadingOverlay.style.display = 'none';
        sheet.style.pointerEvents = '';
        isBusy = false;
        isErrorState = false; 
      }, 300);
    }
  }

  function createLoadingText(container) {
    let el = document.createElement('div');
    el.className = 'loading-text';
    container.appendChild(el);
    return el;
  }

  function activateErrorMode() {
    isErrorState = true;
    setLoading(true, t('swipe_to_refresh', "Glissez vers le bas pour vérifier"));
  }

  function wait(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

  // --- MOTEUR SÉCURISÉ ---
  function executeSecureAction(actionType, payload, isForm = false) {
    if (isBusy && !isErrorState) return Promise.resolve(); 
    
    setLoading(true);

    let url = '';
    let options = {
        method: 'POST',
        headers: { 
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json' 
        }
    };

    if (actionType === 'add') {
        url = buildUrl('cart/add.js');
        if (isForm) {
            options.body = payload;
        } else {
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(payload);
        }
    } else if (actionType === 'change') {
        url = buildUrl('cart/change.js');
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
    }

    return Promise.all([
        fetch(url, options).then(async (response) => {
            const text = await response.text();
            
            // SÉCURITÉ : Détection Cloudflare
            if (text.trim().startsWith('<')) {
                console.warn("MCD: Réponse HTML (Cloudflare Challenge probable)");
                throw new Error("HTML_ERROR"); // Déclenche le mode Swipe
            }
            try {
                const data = JSON.parse(text);
                if (data.status && data.status >= 400) throw new Error(data.description || data.message);
                return data;
            } catch (e) {
                if (e.message !== "HTML_ERROR" && !e.message.includes("description")) {
                     throw new Error("JSON_PARSE_ERROR"); 
                }
                throw e; 
            }
        }),
        wait(1500) 
    ])
    .then(([data, _]) => {
        triggerHaptic();
        return Promise.all([
            refreshCart(),
            fetch(buildUrl('cart.js')).then(r => r.json()).then(cart => updateDrawerInfo(cart))
        ]).then(() => data);
    })
    .then((data) => {
        setLoading(false);

        if (drawer.classList.contains('is-packaging-mode') && actionType === 'add') {
             drawer.classList.remove('is-packaging-mode');
        }

        if (actionType === 'add' && !drawer.classList.contains('is-packaging-mode')) {
             if (isDesktop()) {
                 if (!drawer.classList.contains('is-expanded')) expand();
             } else {
                 if (!drawer.classList.contains('is-expanded')) openPeek(data);
             }
        }
        return data; 
    })
    .catch(err => {
        console.error("MCD Error:", err);
        if (err.message === "HTML_ERROR" || err.message === "JSON_PARSE_ERROR") {
             activateErrorMode();
        } else {
             showError(err.message);
             setLoading(false);
        }
        throw err; 
    });
  }

  function bindEvents() {
    if (handle) {
      handle.addEventListener('click', (e) => { e.preventDefault(); toggleExpand(); });
      handle.addEventListener('touchstart', dragStart, { passive: false });
    }
    if (headerArea) headerArea.addEventListener('touchstart', dragStart, { passive: false });
    if (peek) {
      peek.addEventListener('click', () => { if (!isDragging) expand(); });
      peek.addEventListener('touchstart', dragStart, { passive: false });
    }
    
    if (loadingOverlay) {
        loadingOverlay.addEventListener('touchstart', dragStart, { passive: false });
        loadingOverlay.addEventListener('touchmove', dragMove, { passive: false });
        loadingOverlay.addEventListener('touchend', dragEnd);
    }

    if (overlay) overlay.addEventListener('click', close);
    const btnClose = document.querySelector(selectors.closeBtn);
    if (btnClose) btnClose.addEventListener('click', close);

    document.addEventListener('touchmove', dragMove, { passive: false });
    document.addEventListener('touchend', dragEnd);
    
    document.addEventListener('click', handleDelegatedClicks);
    document.addEventListener('change', handleDelegatedChanges);
    document.addEventListener('input', handleDelegatedInput); 

    document.body.addEventListener('click', function(e) {
      const trigger = e.target.closest('a[href="/cart"], .header__icon--cart, #cart-icon-bubble, [data-action="open-drawer"]');
      if (trigger) { e.preventDefault(); e.stopPropagation(); expand(); }
    }, true); 

    const checkoutBtn = document.querySelector(selectors.checkoutBtn);
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (isBusy && !isErrorState) return; 
            const form = document.querySelector(selectors.cartForm);
            if (form) {
                if (!form.querySelector('input[name="checkout"]')) {
                    const input = document.createElement("input");
                    input.type = "hidden"; input.name = "checkout"; input.value = "true";
                    form.appendChild(input);
                }
                form.submit();
            } else { window.location.href = buildUrl('checkout'); }
        });
    }
  }

  function handleDelegatedClicks(e) {
    if (!drawer || (isBusy && !isErrorState)) return;

    const openPkg = e.target.closest(selectors.btnOpenPkg);
    const closePkg = e.target.closest(selectors.btnClosePkg);
    const deleteBtn = e.target.closest('.js-mcd-delete-item');
    const giftBtn = e.target.closest('.js-mcd-add-gift-btn');
    const pkgBtn = e.target.closest('.js-mcd-add-packaging-btn');
    const suggestionBtn = e.target.closest('.js-mcd-add-suggestion-btn');

    if (openPkg) { e.preventDefault(); removeUndoToast(); drawer.classList.add('is-packaging-mode'); }
    if (closePkg) { e.preventDefault(); drawer.classList.remove('is-packaging-mode'); }

    if (giftBtn || pkgBtn || suggestionBtn || deleteBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
  }

    if (giftBtn) executeSecureAction('add', { id: giftBtn.dataset.variantId, quantity: 1 });
    if (pkgBtn) executeSecureAction('add', { id: pkgBtn.dataset.variantId, quantity: 1 });
    if (suggestionBtn) {
        executeSecureAction('add', {
            id: suggestionBtn.dataset.variantId,
            quantity: 1
        });
    }
    if (deleteBtn) initiateDelete(deleteBtn.dataset.key, deleteBtn.dataset.variantId, deleteBtn.dataset.qty || 1);
  }

  function handleDelegatedInput(e) {
     const qtySelect = e.target.closest('.js-mcd-qty-select');
     if (!qtySelect) return;
     if (debounceTimer) clearTimeout(debounceTimer);
     debounceTimer = setTimeout(() => {
         const newQty = parseInt(qtySelect.value, 10);
         if (newQty >= 0) executeSecureAction('change', { id: qtySelect.dataset.key, quantity: newQty });
     }, 800);
  }

  function handleDelegatedChanges(e) {
    const qtySelect = e.target.closest('.js-mcd-qty-select');
    if (qtySelect && !debounceTimer) {
        e.stopImmediatePropagation();
        executeSecureAction('change', { id: qtySelect.dataset.key, quantity: parseInt(qtySelect.value, 10) });
    }
  }

  function hijackCartForms() {
  document.addEventListener('submit', function(e) {
    const form = e.target;
    // Ignorer les forms Judge.me
    if (form.classList.contains('jdgm-form') || form.classList.contains('jdgm-question-form')) return;
    const isCartAdd = form.getAttribute('action')?.indexOf('cart/add') !== -1;
    if (e.submitter?.name === 'checkout' || (!isCartAdd && !form.closest(selectors.drawer)) || form.getAttribute('data-skip-hijack')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    executeSecureAction('add', new FormData(form), true);
  }, true);
}

  function initiateDelete(key, variantId, qtyToRestore) {
      if (isBusy && !isErrorState) return;
      executeSecureAction('change', { id: key, quantity: 0 })
      .then(() => {
          checkEmpty();
          if (variantId) showUndoToast(variantId, qtyToRestore);
      })
      .catch(e => console.log('Delete aborted or failed'));
  }

  function showUndoToast(variantId, qty) {
    removeUndoToast();
    const footer = document.querySelector('.drawer-footer');
    const toast = document.createElement('div');
    
    // On ajoute les classes du thème pour le toast ANNULER
    toast.className = 'cart-undo-toast button button--primary'; 
    
    toast.innerHTML = `<span>${t('item_removed', 'Article supprimé')}</span><button id="btn-undo-action">${t('undo', 'ANNULER')}</button>`;
    
    Object.assign(toast.style, {
      position: 'fixed', bottom: (footer?.offsetHeight || 0) + 'px', 
      left: isDesktop() ? 'auto' : '0', right: isDesktop() ? '0' : 'auto',
      width: isDesktop() ? '450px' : '100%', 
      padding: '18px 25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      boxSizing: 'border-box', zIndex: '2147483650', fontSize: '13px', opacity: '0', 
      transform: 'translateY(20px)', transition: 'all 0.3s ease'
    });

    document.body.appendChild(toast);
    
    requestAnimationFrame(() => { 
        toast.classList.add('show');
        toast.style.opacity = '1'; 
        toast.style.transform = 'translateY(0)'; 
    });

    toast.querySelector('#btn-undo-action').onclick = () => {
      toast.remove();
      executeSecureAction('add', { id: variantId, quantity: qty });
    };

    undoToastTimer = setTimeout(() => {
       toast.classList.remove('show');
       toast.style.opacity = '0';
       setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  function removeUndoToast() {
    document.querySelector('.cart-undo-toast')?.remove();
    if (undoToastTimer) clearTimeout(undoToastTimer);
  }

  function updateDrawerInfo(cart) {
    const totalEl = document.querySelector(selectors.totalPrice);
    if (totalEl) totalEl.innerHTML = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
    document.querySelectorAll(selectors.countElements).forEach(el => {
      const count = cart.item_count;
      if (el.tagName === 'SPAN' || el.children.length === 0) el.textContent = count;
      else if (el.querySelector('span')) el.querySelector('span').textContent = count;
      el.classList.toggle('is-hidden', count === 0);
    });
  }

  function refreshCart() {
    const url = buildUrl(`?section_id=${drawer.dataset.sectionId}`);
    return fetch(url)
      .then(r => { if (!r.ok) throw new Error(); return r.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelector('#drawer-items-container');
        if (!newItems) return;

        ['#drawer-gift-container', '#drawer-items-container'].forEach(id => {
            const newVal = doc.querySelector(id);
            const curr = drawer.querySelector(id);
            if (newVal) curr ? curr.replaceWith(newVal) : drawer.querySelector('.drawer-scrollable').insertAdjacentElement('afterbegin', newVal);
            else if (newItems.innerHTML.trim().length === 0) curr?.remove();
        });
      })
      .catch(e => console.log('Refresh UI skip'));
  }

  function openPeek(data) {
    if (isDesktop()) return;
    const item = data.items ? data.items[0] : data;
    if (!item) return;

    document.querySelector(selectors.peekImg).src = item.featured_image?.url || item.featured_image || item.image;
    document.querySelector(selectors.peekTitle).textContent = item.product_title || item.title;
    document.querySelector(selectors.peekPrice).textContent = (item.final_price / 100).toFixed(2).replace('.', ',') + ' €';

    drawer.classList.remove('is-expanded');
    drawer.classList.add('is-peek');
    if (peekTimer) clearTimeout(peekTimer);
    peekTimer = setTimeout(() => { if (drawer.classList.contains('is-peek')) close(); }, 4000);
  }

  function dragStart(e) {
    if (isDesktop()) return;
    
    // Si on touche le voile en mode erreur, on laisse passer pour le swipe
    if (e.target.closest(selectors.loading)) {
        if (!isErrorState) {
            return; // Bloque le swipe si pas d'erreur
        }
    }

    if (e.target.closest(selectors.closeBtn) && !isErrorState) return; 
    
    isDragging = true;
    startY = e.touches[0].clientY;
    sheet.style.transition = 'none';
  }

  function dragMove(e) {
    if (!isDragging) return;
    currentY = e.touches[0].clientY;
    const delta = currentY - startY;
    
    if (e.cancelable) e.preventDefault();

    // --- LOGIQUE ERREUR (SWIPE DOWN / BAS) ---
    if (isErrorState) {
        if (delta > 0) {
            sheet.style.transform = `translateY(${delta / 3}px)`; 
        }
        return;
    }

    let newTranslate = drawer.classList.contains('is-expanded') ? Math.max(0, (delta / window.innerHeight) * 100) : 85 + (delta / window.innerHeight * 100);
    sheet.style.transform = `translateY(${newTranslate}%)`;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    sheet.style.transition = '';
    const delta = currentY - startY;

    // --- DÉCLENCHEMENT DU POST MASQUÉ ---
    // Cette partie ne s'active QUE si isErrorState est TRUE
    if (isErrorState) {
        if (delta > 100) { 
            sessionStorage.setItem('mcd-reopen-after-refresh', 'true');
            
            const form = document.querySelector(selectors.cartForm);
            if (form) {
                // CORRECTION 404 : On utilise l'URL système /cart/update
                // Cela permet le POST (Cloudflare OK) sans erreur de route.
                form.action = buildUrl('cart/update'); 
                
                // On ajoute un champ caché pour forcer le retour sur la page actuelle
                let returnInput = form.querySelector('input[name="return_to"]');
                if (!returnInput) {
                    returnInput = document.createElement('input');
                    returnInput.type = 'hidden';
                    returnInput.name = 'return_to';
                    form.appendChild(returnInput);
                }
                returnInput.value = window.location.pathname; 
                
                form.submit();
            } else {
                window.location.reload(); 
            }
        } else {
            sheet.style.transform = ''; 
        }
        return;
    }

    if (Math.abs(delta) < 50) { sheet.style.transform = ''; return; }
    delta > 100 || (delta > 50 && drawer.classList.contains('is-peek')) ? close() : expand();
  }

  function expand() {
    if (isErrorState) return;
    if (peekTimer) clearTimeout(peekTimer);
    triggerHaptic();
    drawer.classList.replace('is-peek', 'is-expanded') || drawer.classList.add('is-expanded');
    sheet.style.transform = '';
    document.body.classList.add('overflow-hidden');
  }

  function toggleExpand() { drawer.classList.contains('is-expanded') ? close() : expand(); }

  function close() {
    removeUndoToast();
    drawer.classList.remove('is-peek', 'is-expanded', 'is-packaging-mode');
    sheet.style.transform = '';
    document.body.classList.remove('overflow-hidden');
  }

  function showError(msg) {
    const err = document.createElement('div');
    
    // MODIFICATION ICI : On ajoute 'button button--primary' pour que le toast ERREUR prenne aussi la couleur du thème
    err.className = 'cart-error-toast button button--primary';
    
    err.textContent = t('error_generic', msg || 'Une erreur est survenue');
    
    Object.assign(err.style, {
        position: 'fixed', top: '20px', left: '50%',
        transform: 'translateX(-50%) translateY(-100px)',
        zIndex: '2147483650',
        width: 'auto', minWidth: '300px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '15px 25px', boxSizing: 'border-box'
    });

    document.body.appendChild(err);
    
    requestAnimationFrame(() => { 
        err.classList.add('show');
        err.style.transform = 'translateX(-50%) translateY(0)';
    });
    
    setTimeout(() => { 
        err.classList.remove('show'); 
        err.style.transform = 'translateX(-50%) translateY(-100px)';
        setTimeout(() => err.remove(), 300); 
    }, 3000);
  }

  function checkEmpty() { if (document.querySelectorAll('.drawer-item').length === 0) refreshCart(); }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  return { init, expand, close, openPeek };
})();